import React, { useEffect } from 'react'
import { PRESCRIPTION_LAYOUTS } from 'src/consumer/constants'
import {
  PMPHeaderDoctorText,
  PMPHeaderLeftPart,
  PMPHeaderRightPart,
  PMPHeadingBanner,
} from 'src/mentor/components/PrescriptionMakingPage/PrescriptionMakingPageStyles'
import PrescriptionKVItem from 'src/mentor/components/PrescriptionMakingPage/prescriptionTemplate/common/PrescriptionKVItem'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { ensureNotoSansDevanagariLoaded } from 'src/utils/loadOnDemandFonts'

export default function TwoDoctorHeader({
  prescriptionData,
  leaveSpace,
  debug = false,
  topPadding = '2px',
}) {
  const currentLayout = prescriptionData?.layout

  useEffect(() => {
    ensureNotoSansDevanagariLoaded()
  }, [])

  // PRESCRIPTION_LAYOUTS.listPointersFooter

  return (
    <>
      <PMPHeadingBanner
        debug={debug}
        noColor={true}
        style={{
          paddingTop: topPadding,
          flexDirection: 'row',
          justifyContent: 'center',
          letterSpacing: '0px',
          gap: '16px',
        }}
      >
        <div style={{ aspectRatio: 1, width: '70px', height: '70px' }}>
          {!!prescriptionData?.clinicBrandLogo && (
            <img
              style={{ width: '100%', height: '100%' }}
              src={getImageLink(prescriptionData?.clinicBrandLogo)}
              alt="clinicBrandLogo"
            ></img>
          )}
        </div>
        <div
          className="d-flex flex-column"
          style={{ fontFamily: "'Noto Sans Devanagari'", fontSize: '16px' }}
        >
          <div
            style={{
              border: '2px solid #000',
              borderRadius: '8px',
              padding: '0 24px',
              fontSize: '1.8em',
              fontWeight: '900',
            }}
          >
            <span>{prescriptionData?.header?.title}</span>
          </div>
          {prescriptionData?.header?.subTitle && (
            <span className="sub-heading" style={{ fontSize: '1em' }}>
              {prescriptionData?.header?.subTitle}
            </span>
          )}
        </div>
        <div style={{ aspectRatio: 1, width: '50px' }}></div>
      </PMPHeadingBanner>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <PMPHeaderLeftPart>
          <DoctorContainer
            layoutType={currentLayout}
            doctorName={prescriptionData?.doctorName}
            designation={prescriptionData?.designation}
            listOfDegrees={prescriptionData?.listOfDegrees}
            regId={prescriptionData?.regId}
            contactEmail={prescriptionData?.contactEmail}
            website={prescriptionData?.website}
            cmoRegId={prescriptionData?.cmoRegId}
            affiliations={prescriptionData?.affiliations}
            doctorOtherDetails={prescriptionData?.doctorOtherDetails}
          />
        </PMPHeaderLeftPart>
        <PMPHeaderRightPart
          style={{
            flexShrink: 0,
            width: 'unset',
            textAlign: 'right',
          }}
        >
          <DoctorContainer
            layoutType={currentLayout}
            doctorName={prescriptionData?.otherDoctorInfos[0]?.doctorName}
            designation={prescriptionData?.otherDoctorInfos[0]?.designation}
            listOfDegrees={prescriptionData?.otherDoctorInfos[0]?.listOfDegrees}
            regId={prescriptionData?.otherDoctorInfos[0]?.regId}
            contactEmail={prescriptionData?.otherDoctorInfos[0]?.contactEmail}
            website={prescriptionData?.otherDoctorInfos[0]?.website}
            cmoRegId={prescriptionData?.otherDoctorInfos[0]?.cmoRegId}
            affiliations={prescriptionData?.otherDoctorInfos[0]?.affiliations}
            doctorOtherDetails={prescriptionData?.otherDoctorInfos[0]?.doctorOtherDetails}
          />
        </PMPHeaderRightPart>
      </div>
    </>
  )
}

function DoctorContainer({
  layoutType,
  doctorName,
  designation,
  listOfDegrees,
  regId,
  contactEmail,
  website,
  cmoRegId,
  affiliations,
  doctorOtherDetails,
}) {
  return (
    <>
      <PMPHeaderDoctorText
        main
        style={{
          fontSize: layoutType === PRESCRIPTION_LAYOUTS.listPointersFooter ? '18px' : 'unset',
        }}
      >
        {doctorName}
      </PMPHeaderDoctorText>
      <PMPHeaderDoctorText>{designation}</PMPHeaderDoctorText>
      <PMPHeaderDoctorText>{listOfDegrees?.join(', ')}</PMPHeaderDoctorText>
      {regId && (
        <PMPHeaderDoctorText>
          <PrescriptionKVItem
            itemKey="Regn No."
            topContainerProps={{
              className: 'd-flex align-items-center gap-1',
            }}
            value={regId}
          />
        </PMPHeaderDoctorText>
      )}
      {contactEmail && (
        <PMPHeaderDoctorText>
          <PrescriptionKVItem
            itemKey="Email"
            topContainerProps={{
              className: 'd-flex align-items-center gap-1',
            }}
            value={contactEmail}
          />
        </PMPHeaderDoctorText>
      )}
      {website && (
        <PMPHeaderDoctorText>
          <PrescriptionKVItem
            itemKey="Website"
            topContainerProps={{
              className: 'd-flex align-items-center gap-1',
            }}
            value={website}
          />
        </PMPHeaderDoctorText>
      )}
      {cmoRegId && (
        <PMPHeaderDoctorText>
          <PrescriptionKVItem
            itemKey="C.M.O. Regd. No."
            topContainerProps={{
              className: 'd-flex align-items-center gap-1',
            }}
            value={cmoRegId}
          />
        </PMPHeaderDoctorText>
      )}
      {affiliations?.map((affiliation, affIndex) => (
        <PMPHeaderDoctorText key={affIndex}>
          <b>{affiliation}</b>
        </PMPHeaderDoctorText>
      ))}
      {doctorOtherDetails?.map((detail, detailIndex) => (
        <PMPHeaderDoctorText className="fw-light" key={detailIndex}>
          <b>{detail}</b>
        </PMPHeaderDoctorText>
      ))}
    </>
  )
}
